import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

Vue.config.devtools = true;

import uxModule from "./Modules/uxModule";
import sharedModule from "./Modules/sharedModule";
import securityModule from "./Modules/securityModule";
import payrollModule from "./Modules/payrollModule";
import paidSickLeaveModule from "./Modules/paidSickLeaveModule";
import evalInvoiceModule from "./Modules/evalInvoiceModule";

const state = {};

const mutations = {};

const actions = {};

const store = new Vuex.Store({
  modules: {
    uxModule: uxModule,
    sharedModule: sharedModule,
    securityModule: securityModule,
    payrollModule: payrollModule,
    paidSickLeaveModule: paidSickLeaveModule,
    evalInvoiceModule: evalInvoiceModule,
  },

  state,
  mutations,
  actions,
});

export default store;
